import { render, staticRenderFns } from "./FormSuffix.vue?vue&type=template&id=733cdc97&scoped=true&"
import script from "./FormSuffix.vue?vue&type=script&lang=js&"
export * from "./FormSuffix.vue?vue&type=script&lang=js&"
import style0 from "./FormSuffix.vue?vue&type=style&index=0&id=733cdc97&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733cdc97",
  null
  
)

export default component.exports